<template>
	<div class="w-100 h-100 d-flex flex-row align-center justify-space-between">


		<router-link to="/">
			<img :src="AppConfigs.staticImages.LOGO" height="30" min-width="134" />
		</router-link>



		<HeaderNavigationLinks v-if="isDesktopDevice" />

		

		<button to="/earn" @click="loginButtonClicked"
			class="button--primary rounded-pill header-login-btn">
			Log in
		</button>


	</div>
</template>



<script setup>

import { isDesktop } from "@/utils/utils";
import { AppConfigs } from "@/app.configs";
import authEvents from "@/Events/AuthDialog";
import HeaderNavigationLinks from "@/components/Header/Header-Navigation-Links.vue";

const isDesktopDevice = isDesktop();


const loginButtonClicked = () => {
	authEvents.emit('open-auth-dialog');
};

</script>



<style scoped lang="scss">
@use "@/assets/scss/components/header.scss" as header;

</style>